/* REACT */
import React, { useEffect, useState } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import TurndownService from 'turndown'
import { logAction } from '../../../../utils/actionLogger'

/* COMPONENTS */
import { Image } from '../../../../components/ui'

/* STORE */
import { sendAssistantResponseFeedback } from '../../../../store/maya/actions'

/* STYLES */
import {
  MessageContainer,
  MessageTextContainer,
  MessageAvatarContainer,
  DisclaimerMessage,
  HallucinationDisclaimerMessage,
  FeedbackContainer,
  LeaveFeedbackText,
  MessageContentContainer,
  FeedbackIconWrapper,
  FeedbackIcon,
  FeedbackIconTooltipText,
} from './style'

/* UTILS/CONSTANTS */
import {
  CLIENT_STYLINGS,
  CLOUDFRONT_BASE_URL,
  MAYA_INTENTS,
} from '../../../../utils/constants'
import {
  handleIncompleteMarkdownLinks,
  getTranslations,
  Analytics,
} from '../../../../utils'

/* ASSETS */

const MessageComponent = ({
  language,
  message,
  content,
  disclaimer,
  sender,
  intent,
  organizationSlug,
  key,
  id,
  showFeedbackOption,
  slug,
  token,
  removeMarginBottom,
}) => {
  const MayaAvatar = CLIENT_STYLINGS[organizationSlug].MAYA_AVATAR_URL
  const UserAvatar = `${CLOUDFRONT_BASE_URL}/assets/${organizationSlug}/images/UserAvatar.png`

  const [formattedMessage, setFormattedMessage] = useState(
    handleIncompleteMarkdownLinks(content)
  )
  const [markdownDisclaimer, setMarkdownDisclaimer] = useState('')

  const sendFeedback = async feedback => {
    sendAssistantResponseFeedback({ slug, token, id: message.id, feedback })
  }

  const hasPositiveFeedback = () => {
    if (!message?.assistantResponseFeedbacks?.length) return false

    // IF ANY FEEDBACK OF TYPE USER HAS GIVEN POSITIVE FEEDBACK

    let feedback = message?.assistantResponseFeedbacks.filter(
      feedback => feedback.type === 'user'
    )[0]?.feedback

    if (feedback === 1) return true

    return false
  }

  const hasNegativeFeedback = () => {
    if (!message?.assistantResponseFeedbacks?.length) return false

    // IF ANY FEEDBACK OF TYPE USER HAS GIVEN NEGATIVE FEEDBACK

    let feedback = message?.assistantResponseFeedbacks.filter(
      feedback => feedback.type === 'user'
    )[0]?.feedback

    if (feedback === 0) return true

    return false
  }

  useEffect(() => {
    if (!disclaimer) return
    const turndownService = new TurndownService()

    // Custom rule to avoid escaping markdown link characters
    turndownService.addRule('unescapeLinks', {
      filter: 'a',
      replacement: (content, node) => {
        const href = node.getAttribute('href')
        return `[${content}](${href})`
      },
    })

    let markdownContent = turndownService.turndown(disclaimer)

    // Remove unnecessary escaping of Markdown characters
    markdownContent = markdownContent.replace(/\\([\[\]])/g, '$1')

    setMarkdownDisclaimer(markdownContent)
  }, [disclaimer])

  useEffect(() => {
    setTimeout(() => {
      let element = document.getElementById(`disclaimer-msg-${key}`)
      if (element) {
        document
          .getElementById(`disclaimer-msg-${key}`)
          .querySelectorAll('a')
          .forEach(element => {
            if (element) {
              element.setAttribute(
                'style',
                `font-style: italic;font-size: 14px;font-family: ${CLIENT_STYLINGS[organizationSlug].FONTS.PRIMARY}};color: #4183c4;`
              )
              element.setAttribute('target', '_blank')
            }
          })
      }
    }, 100)
  }, [disclaimer])

  return (
    <MessageContainer sender={sender} key={key}>
      <MessageContentContainer sender={sender} id={id}>
        {!sender && (
          <MessageAvatarContainer sender={sender}>
            <Image
              src={MayaAvatar}
              alt='Message Avatar'
              width={'40px'}
              height={'40px'}
              minWidth={'40px'}
              minHeight={'40px'}
              objectFit={'contain'}
            />
          </MessageAvatarContainer>
        )}
        <MessageTextContainer
          sender={sender}
          hasIntent={
            intent &&
            intent?.type !== MAYA_INTENTS.qa.key &&
            intent?.type !== MAYA_INTENTS.llt_qa.key &&
            intent?.type !== MAYA_INTENTS.entity_specific_qa.key
          }
        >
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a(props) {
                // OPEN LINKS IN NEW TABS
                const { node, href, ...rest } = props
                return (
                  <a
                    {...rest}
                    href={href}
                    target='_blank'
                    onClick={e => {
                      console.log('Eazy1')
                      Analytics.getInstance().sendEvent('maya_url_click_chat', {
                        item_url: href,
                        item_type: 'text',
                        item_title:
                          e.currentTarget.textContent?.trim() || undefined,
                      })
                      logAction({
                        name: 'url_click_chat',
                        url: href,
                        linkLabel:
                          e.currentTarget.textContent?.trim() || undefined,
                      })
                    }}
                  />
                )
              },
              p(props) {
                // OPEN LINKS IN NEW TABS
                const { node, ...rest } = props
                return <p {...rest} />
              },
              ol(props) {
                // OPEN LINKS IN NEW TABS
                const { node, ...rest } = props
                return <ol {...rest} />
              },
              ul(props) {
                // OPEN LINKS IN NEW TABS
                const { node, ...rest } = props
                return (
                  <ul
                    style={{
                      color: sender
                        ? CLIENT_STYLINGS[organizationSlug].COLOR.PAPER_00
                        : CLIENT_STYLINGS[organizationSlug].COLOR
                            .TEXT_COLOR_100,
                      'font-size': '14px',
                      'font-family': `${CLIENT_STYLINGS[organizationSlug].FONTS.PRIMARY}`,
                    }}
                    {...rest}
                  />
                )
              },
            }}
          >
            {formattedMessage}
          </ReactMarkdown>

          {disclaimer ? (
            <>
              <br />
              <DisclaimerMessage
                id={`disclaimer-msg-${key}`}
                hasHallucination={false}
              >
                <ReactMarkdown
                  components={{
                    a(props) {
                      // OPEN LINKS IN NEW TABS
                      const { node, href, ...rest } = props
                      return (
                        <a
                          style={{
                            'font-size': '11px',
                          }}
                          {...rest}
                          href={href}
                          target='_blank'
                          onClick={e => {
                            Analytics.getInstance().sendEvent(
                              'maya_url_click_chat',
                              {
                                item_url: href,
                                item_type: 'text',
                                item_title:
                                  e.currentTarget.textContent?.trim() ||
                                  undefined,
                              }
                            )
                            logAction({
                              name: 'url_click_chat',
                              url: href,
                              linkLabel:
                                e.currentTarget.textContent?.trim() ||
                                undefined,
                            })
                          }}
                        />
                      )
                    },
                    p(props) {
                      // OPEN LINKS IN NEW TABS
                      const { node, ...rest } = props
                      return (
                        <p
                          style={{
                            color:
                              CLIENT_STYLINGS[organizationSlug].COLOR.SLATE_50,
                            'font-size': '11px',
                          }}
                          {...rest}
                        />
                      )
                    },
                    ol(props) {
                      // OPEN LINKS IN NEW TABS
                      const { node, ...rest } = props
                      return (
                        <ol
                          style={{
                            color:
                              CLIENT_STYLINGS[organizationSlug].COLOR.SLATE_50,
                            'font-size': '11px',
                          }}
                          {...rest}
                        />
                      )
                    },
                    ul(props) {
                      // OPEN LINKS IN NEW TABS
                      const { node, ...rest } = props
                      return (
                        <ul
                          style={{
                            color: sender
                              ? CLIENT_STYLINGS[organizationSlug].COLOR.PAPER_00
                              : CLIENT_STYLINGS[organizationSlug].COLOR
                                  .SLATE_50,
                            'font-size': '11px',
                          }}
                          {...rest}
                        />
                      )
                    },
                  }}
                >
                  {markdownDisclaimer}
                </ReactMarkdown>
              </DisclaimerMessage>
            </>
          ) : null}

          {message?.hallucination?.status && message?.hallucination?.content ? (
            <>
              <br />
              <HallucinationDisclaimerMessage id={`disclaimer-msg-${key}`}>
                <ReactMarkdown
                  components={{
                    a(props) {
                      // OPEN LINKS IN NEW TABS
                      const { node, href, ...rest } = props
                      return (
                        <a
                          {...rest}
                          href={href}
                          target='_blank'
                          style={{
                            color: '#E3242B',
                            'font-size': '14px',
                            'font-family': `${CLIENT_STYLINGS[organizationSlug].FONTS.PRIMARY}`,
                          }}
                          onClick={e => {
                            Analytics.getInstance().sendEvent(
                              'maya_url_click_chat',
                              {
                                item_url: href,
                                item_type: 'text',
                                item_title:
                                  e.currentTarget.textContent?.trim() ||
                                  undefined,
                              }
                            )
                            logAction({
                              name: 'url_click_chat',
                              url: href,
                              linkLabel:
                                e.currentTarget.textContent?.trim() ||
                                undefined,
                            })
                          }}
                        />
                      )
                    },
                    p(props) {
                      // OPEN LINKS IN NEW TABS
                      const { node, ...rest } = props
                      return (
                        <p
                          {...rest}
                          style={{
                            color: '#E3242B',
                            'font-size': '14px',
                            'font-family': `${CLIENT_STYLINGS[organizationSlug].FONTS.PRIMARY}`,
                          }}
                        />
                      )
                    },
                    ol(props) {
                      // OPEN LINKS IN NEW TABS
                      const { node, ...rest } = props
                      return (
                        <ol
                          {...rest}
                          style={{
                            color: '#E3242B',
                            'font-size': '14px',
                            'font-family': `${CLIENT_STYLINGS[organizationSlug].FONTS.PRIMARY}`,
                          }}
                        />
                      )
                    },
                    ul(props) {
                      // OPEN LINKS IN NEW TABS
                      const { node, ...rest } = props
                      return (
                        <ul
                          style={{
                            color: '#E3242B',
                            'font-size': '14px',
                            'font-family': `${CLIENT_STYLINGS[organizationSlug].FONTS.PRIMARY}`,
                          }}
                          {...rest}
                        />
                      )
                    },
                  }}
                >
                  {message.hallucination.content}
                </ReactMarkdown>
              </HallucinationDisclaimerMessage>
            </>
          ) : null}
        </MessageTextContainer>

        {sender && (
          <MessageAvatarContainer sender={sender}>
            <Image
              src={UserAvatar}
              alt='Message Avatar'
              width={'40px'}
              height={'40px'}
              minWidth={'40px'}
              minHeight={'40px'}
              style={{ borderRadius: '30px', objectFit: 'cover' }}
            />
          </MessageAvatarContainer>
        )}
      </MessageContentContainer>

      {/* MESSAGE MUST HAVE A DB ID TO SHOW FEEDBACK BUTTON */}
      {showFeedbackOption && message?.id ? (
        <FeedbackContainer key={key} removeMarginBottom={removeMarginBottom}>
          <LeaveFeedbackText>
            {getTranslations('leave_feedback')}:
          </LeaveFeedbackText>
          {!message?.assistantResponseFeedbacks?.length ||
          hasPositiveFeedback() ? (
            <FeedbackIconWrapper>
              <FeedbackIconTooltipText className='tooltip-text'>
                {getTranslations('good_response')}
              </FeedbackIconTooltipText>
              <FeedbackIcon
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                fill='none'
                viewBox='0 0 24 24'
                class='icon-md-heavy'
                saved={hasPositiveFeedback()}
                disabled={hasPositiveFeedback()}
                onClick={() => {
                  sendFeedback(1)
                }}
              >
                {!message?.assistantResponseFeedbacks?.length ? (
                  <path
                    fill-rule='evenodd'
                    d='M12.132 2.504a1 1 0 0 1 .992-.496l.454.056a4 4 0 0 1 3.327 5.146L16.354 9h.718c2.638 0 4.553 2.508 3.86 5.053l-1.364 5A4 4 0 0 1 15.708 22H6a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h2c.26 0 .5-.14.628-.364zM10 20h5.709a2 2 0 0 0 1.93-1.474l1.363-5A2 2 0 0 0 17.072 11H15a1 1 0 0 1-.956-1.294l.95-3.084a2 2 0 0 0-1.462-2.537l-3.168 5.543A2.72 2.72 0 0 1 9 10.81V19a1 1 0 0 0 1 1m-3-9v8c0 .35.06.687.17 1H6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1z'
                    clip-rule='evenodd'
                  ></path>
                ) : (
                  <path d='M12.592 2.504a.99.99 0 0 1 1.06-.485c1.91.384 3.073 2.342 2.5 4.212L15.303 9h1.711c2.627 0 4.535 2.508 3.843 5.053l-1.358 5A3.986 3.986 0 0 1 15.656 22H9.967a1.996 1.996 0 0 1-1.988-2V9h.338a1 1 0 0 0 .865-.504zM5.988 9A2.994 2.994 0 0 0 3 12v7c0 1.657 1.338 3 2.988 3h.533a4 4 0 0 1-.533-2z'></path>
                )}
              </FeedbackIcon>
            </FeedbackIconWrapper>
          ) : null}
          {!message?.assistantResponseFeedbacks?.length ||
          hasNegativeFeedback() ? (
            <FeedbackIconWrapper>
              <FeedbackIconTooltipText className='tooltip-text'>
                {getTranslations('bad_response')}
              </FeedbackIconTooltipText>
              <FeedbackIcon
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                fill='none'
                viewBox='0 0 24 24'
                class='icon-md-heavy'
                saved={hasNegativeFeedback()}
                disabled={hasNegativeFeedback()}
                onClick={() => {
                  sendFeedback(0)
                }}
              >
                {!message?.assistantResponseFeedbacks?.length ? (
                  <path
                    fill-rule='evenodd'
                    d='M11.873 21.496a1 1 0 0 1-.992.496l-.454-.056A4 4 0 0 1 7.1 16.79L7.65 15h-.718c-2.637 0-4.553-2.508-3.859-5.052l1.364-5A4 4 0 0 1 8.296 2h9.709a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-2c-.26 0-.5.14-.628.364zM14.005 4h-5.71a2 2 0 0 0-1.929 1.474l-1.363 5A2 2 0 0 0 6.933 13h2.072a1 1 0 0 1 .955 1.294l-.949 3.084a2 2 0 0 0 1.462 2.537l3.167-5.543a2.72 2.72 0 0 1 1.364-1.182V5a1 1 0 0 0-1-1m3 9V5c0-.35-.06-.687-.171-1h1.17a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1z'
                    clip-rule='evenodd'
                  ></path>
                ) : (
                  <path
                    fill='currentColor'
                    d='M11.408 21.496a.99.99 0 0 1-1.06.485c-1.91-.384-3.073-2.342-2.5-4.212L8.697 15H6.986c-2.627 0-4.534-2.507-3.843-5.052l1.358-5A3.986 3.986 0 0 1 8.344 2h5.689a1.996 1.996 0 0 1 1.988 2v11h-.338a1 1 0 0 0-.865.504zM18.012 15A2.994 2.994 0 0 0 21 12V5c0-1.657-1.338-3-2.988-3h-.533c.34.588.533 1.271.533 2z'
                  ></path>
                )}
              </FeedbackIcon>
            </FeedbackIconWrapper>
          ) : null}
        </FeedbackContainer>
      ) : null}
    </MessageContainer>
  )
}

const mapStateToProps = state => ({
  intent: state.maya.intent,
  organizationSlug: state.general.organizationSlug,
  slug: state?.maya?.slug,
  token: state?.maya?.token,
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MessageComponent)
